var _style, _path, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgE1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 1000 1000",
    style: {
      enableBackground: "new 0 0 1000 1000"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:#FFFFFF;}\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "st0",
    d: "M855.7,1000H144.3C64.9,1000,0,935.1,0,855.7V144.3C0,64.9,64.9,0,144.3,0h711.4C935.1,0,1000,64.9,1000,144.3 v711.4C1000,935.1,935.1,1000,855.7,1000z"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 178.57,
    width: 128.57,
    height: 128.57
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 307.14,
    width: 128.57,
    height: 128.57
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 435.71,
    width: 128.57,
    height: 128.57
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 564.29,
    width: 128.57,
    height: 128.57
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 692.86,
    width: 128.57,
    height: 128.57
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: 50,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: 178.57,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: 178.57,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: 307.14,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: 307.14,
    y: 307.14,
    width: 128.57,
    height: 128.57
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: 307.14,
    y: 435.71,
    width: 128.57,
    height: 128.57
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: 307.14,
    y: 564.29,
    width: 128.57,
    height: 128.57
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: 307.14,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: 435.71,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: 435.71,
    y: 307.14,
    width: 128.57,
    height: 128.57
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: 435.71,
    y: 435.71,
    width: 128.57,
    height: 128.57
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: 435.71,
    y: 564.29,
    width: 128.57,
    height: 128.57
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: 435.71,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: 564.29,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: 564.29,
    y: 307.14,
    width: 128.57,
    height: 128.57
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: 564.29,
    y: 435.71,
    width: 128.57,
    height: 128.57
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: 564.29,
    y: 564.29,
    width: 128.57,
    height: 128.57
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: 564.29,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: 692.86,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: 692.86,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 50,
    width: 128.57,
    height: 128.57
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 178.57,
    width: 128.57,
    height: 128.57
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 307.14,
    width: 128.57,
    height: 128.57
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 435.71,
    width: 128.57,
    height: 128.57
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 564.29,
    width: 128.57,
    height: 128.57
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 692.86,
    width: 128.57,
    height: 128.57
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: 821.43,
    y: 821.43,
    width: 128.57,
    height: 128.57
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgE1);
export default __webpack_public_path__ + "static/media/e1.4194d7a9902756684933a5c831df93d8.svg";
export { ForwardRef as ReactComponent };